import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestGetDriverContacts } from "./getDriverContacts.request";
import { DriverContactsResponseData } from "./getDriverContacts.types";

const useGetDriverContacts = (
  options?: MutationOptions<
    DriverContactsResponseData,
    ApiServiceError<ApiError>
  >
) => {
  return useMutation({
    mutationFn: requestGetDriverContacts,
    ...options
  });
};

export default useGetDriverContacts;
